import {
  GQFinanceAssetIigccStatus,
  GQEmissionsYearSource,
  GQExternalReportType,
  GQBuildingSizeUnit,
} from '../../generated/graphql';

export function getBuildingSizeUnitFieldUnit(
  buildingSizeUnit: GQBuildingSizeUnit | null
) {
  switch (buildingSizeUnit) {
    case GQBuildingSizeUnit.SquareFeet:
      return 'ft²';
    case GQBuildingSizeUnit.SquareMeters:
      return 'm²';
    case null:
      return null;
  }
}

export function getEmissionsSourceDescriptor({
  emissionsYearSource,
  year,
  publicDisclosureType,
  hasOverrides,
}: {
  emissionsYearSource: GQEmissionsYearSource;
  year: number;
  publicDisclosureType?: GQExternalReportType;
  hasOverrides?: boolean | null;
}) {
  switch (emissionsYearSource) {
    case GQEmissionsYearSource.CompanyEstimatationEngine:
    case GQEmissionsYearSource.BuildingEstimationEngine: {
      if (hasOverrides) {
        return `Estimation with overrides (${year})`;
      }
      return `Estimation (${year})`;
    }
    case GQEmissionsYearSource.WatershedMeasurement:
      return `Watershed disclosure (${year})`;
    case GQEmissionsYearSource.Survey:
      return `Portal responses (${year})`;
    case GQEmissionsYearSource.PrivateCdp:
      return `Private CDP disclosure (${year})`;
    case GQEmissionsYearSource.ManualEntry:
      return `Manual entry`;
    case GQEmissionsYearSource.SurveyEstimate:
      return `Portal (${year})`;
    case GQEmissionsYearSource.PublicDisclosure:
      return publicDisclosureType
        ? `Public report (${year} ${publicDisclosureType})`
        : `Public report (${year})`;
  }
}

export const IIGCC_STATUS_LABELS: Record<GQFinanceAssetIigccStatus, string> = {
  [GQFinanceAssetIigccStatus.NotAligned]: 'Not aligned',
  [GQFinanceAssetIigccStatus.CommittedToAligning]: 'Committed to aligning',
  [GQFinanceAssetIigccStatus.Aligning]: 'Aligning',
  [GQFinanceAssetIigccStatus.Aligned]: 'Aligned',
  [GQFinanceAssetIigccStatus.AchievingNetZero]: 'Achieving net zero',
};
